import { useEffect } from "react";

import { TypedEventEmitter } from "@/common/eventEmmiters/typedEventEmitter";

import { useAppHistory } from "./useAppHistory";

export const NavigationCounterEventName = {
  Change: "Change",
} as const;
export type NavigationCounterEventName =
  (typeof NavigationCounterEventName)[keyof typeof NavigationCounterEventName];

export type NavigationCounterEventsMap = {
  // list of supported events
  [NavigationCounterEventName.Change]: { count: number };
};

// use singleton counter instead of sessionStorage as sessionStorage is not reset between page refreshes in the same tab
class NavigationCounter extends TypedEventEmitter<NavigationCounterEventsMap> {
  private count = 0;

  public get() {
    return this.count;
  }

  public increment() {
    this.count += 1;
    this.emit(NavigationCounterEventName.Change, { count: this.count });
  }
}
export const inAppNavigationCounter = new NavigationCounter();

let isTracking = false;

/** Tracks in-app navigation count and persists it to sessionStorage.
 * NB: must be called once on app startup.
 */
export function useInAppNavigationCountTracking(): void {
  const history = useAppHistory();

  useEffect(() => {
    if (isTracking) {
      return;
    }

    isTracking = true;
    const unsubscribe = history.listen((location, action) => {
      // console.log("history.listen.", { location, action });
      inAppNavigationCounter.increment();
    });

    return () => {
      isTracking = false;
      unsubscribe();
    };
  }, [history]);
}
